import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import { change, untouch, reset as resetForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { toPlainObject, isEmpty } from 'lodash';
import { length, required } from 'redux-form-validators';

import {
    NAME_LENGTH,
    FIRSTNAME_LENGTH,
    CONTACT_MESSAGE_LENGTH,
    FILE_ACCEPTED_FORMAT
} from '../../../constants/form';
import {
    CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED,
    CONTACT_REQUEST_REASON_ID_COMPLAINT,
    CONTACT_REQUEST_REASON_ID_INVALID_EBON,
    CONTACT_REQUEST_REASON_ID_UNSUBSCRIBE,
    CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED_FAQ
} from '../../../constants/index';
import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';
import { ALL, LOGGED } from '../../../services/contactrequest/constants';
import { MODAL_TYPE_DISENROL } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';
import { sendContactRequest, reset } from '../../../services/contactrequest/actions';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import {
    FormComponent,
    EmailInputFieldComponent,
    TextInputFieldComponent,
    SelectFieldComponent,
    TextareaFieldComponent,
    FilesInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import ButtonComponent from '../../button/ButtonComponent';
import SvgComponent from '../../../components/SvgComponent';
import SuccessMessageComponent from '../../successmessage/SuccessMessageComponent';

import './ContactRequestFormComponent.scss';
import LocalizedNavLink from '../../router/LocalizedNavLink';

const FORM_NAME = 'contactrequest-form';

const resetFields = {
    lastname: '',
    firstname: '',
    email: ''
};

const getContactRequestReasonsToOptions = (isAuthed, data = []) =>
    data
        .filter(reason =>
            isAuthed
                ? reason.userLoginState === ALL || reason.userLoginState === LOGGED
                : reason.userLoginState === ALL
        )
        .map(item => ({ label: item.label, value: item.id }));

class ContactRequestFormComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isComplaint: false,
            unsubscribe: false,
            invalidEbon: false,
            cashbackNotReceived: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isAuthed && !nextProps.isAuthed) {
            this.resetFields(FORM_NAME, resetFields);
        }
    }

    submit = data => {
        const { sendContactRequest, resetForm } = this.props;
        sendContactRequest(data, () => {
            resetForm(FORM_NAME);
        });
    };

    handleCloseMessage = () => {
        this.props.reset();
    };

    showDisenrollModal = () => {
        const { history, showModal } = this.props;

        showModal(MODAL_TYPE_DISENROL, {
            id: 'disenroll-modal',
            actionOnClose: () => history.push(PATH.HOME_PATH)
        });
    };

    getUserInfo() {
        const { isAuthed, initialValues } = this.props;
        if (isAuthed) {
            return initialValues;
        }
    }

    handleOnChangeReason = e => {
        const value = e.target.value;
        this.setState({
            isComplaint: value === CONTACT_REQUEST_REASON_ID_COMPLAINT,
            unsubscribe: value === CONTACT_REQUEST_REASON_ID_UNSUBSCRIBE,
            invalidEbon: value === CONTACT_REQUEST_REASON_ID_INVALID_EBON,
            cashbackNotReceived: value === CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED
        });
    };

    resetFields = (formName, fieldsObj) => {
        Object.keys(fieldsObj).forEach(fieldKey => {
            //reset the field's value
            this.props.change(formName, fieldKey, fieldsObj[fieldKey]);

            //reset the field's error
            this.props.untouch(formName, fieldKey);
        });
    };

    render() {
        const {
            i18n,
            i18nFeatureForm,
            isAuthed,
            requestSubmit,
            errorSubmit,
            successSubmit,
            contactRequestReasonsOptions = [],
            errorMessage
        } = this.props;
        const { isComplaint, unsubscribe, invalidEbon, cashbackNotReceived } = this.state;

        return (
            <React.Fragment>
                <FormComponent
                    className="contact-request-form"
                    form={FORM_NAME}
                    classNameInputContainer="grid-2 has-gutter"
                    onSubmit={this.submit}
                    initialValues={this.getUserInfo()}
                    encType
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.BUTTON_SUBMIT}
                    hideButton={unsubscribe}>
                    <EmailInputFieldComponent
                        name="email"
                        label={i18n.LABEL_EMAIL}
                        additionalLabel={isAuthed ? '*' : ''}
                        placeholder={i18n.PLACEHOLDER_EMAIL}
                        classNameInputContainer="mr50"
                        isRequired
                        readOnly={isAuthed}
                        autoComplete="email"
                    />
                    <TextInputFieldComponent
                        name="lastname"
                        label={i18n.LABEL_LASTNAME}
                        placeholder={i18n.PLACEHOLDER_LASTNAME}
                        isRequired
                        hideRequired={isAuthed}
                        readOnly={isAuthed}
                        classNameInputContainer="one-half"
                        autoComplete="family-name"
                        validate={[
                            required({ msg: i18nFeatureForm.REQUIRED }),
                            length({
                                max: NAME_LENGTH,
                                msg: format(i18nFeatureForm.LASTNAME_SIZE_ERROR, NAME_LENGTH)
                            })
                        ]}
                    />
                    <TextInputFieldComponent
                        name="firstname"
                        label={i18n.LABEL_FIRSTNAME}
                        placeholder={i18n.PLACEHOLDER_FIRSTNAME}
                        isRequired
                        hideRequired={isAuthed}
                        readOnly={isAuthed}
                        classNameInputContainer="one-half"
                        autoComplete="given-name"
                        validate={[
                            required({ msg: i18nFeatureForm.REQUIRED }),
                            length({
                                max: FIRSTNAME_LENGTH,
                                msg: format(i18nFeatureForm.FIRSTNAME_SIZE_ERROR, FIRSTNAME_LENGTH)
                            })
                        ]}
                    />
                    <SelectFieldComponent
                        name="requestReasonId"
                        label={i18n.LABEL_CONTACT_REASON}
                        defaultOptionLabel={i18n.DEFAULT_OPTION_LABEL}
                        isRequired
                        options={contactRequestReasonsOptions}
                        classNameInputContainer="one-half"
                        validate={[required({ msg: i18n.SELECT_REQUIRED_MESSAGE })]}
                        onChange={this.handleOnChangeReason}
                    />
                    {isAuthed && (isComplaint || invalidEbon || cashbackNotReceived) ? (
                        <LegendFieldComponent classNameInputContainer="alert-additionnal-message reason one-half">
                            <span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/contactrequest/warning.svg`}
                                    width="39"
                                    height="32"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </span>
                            {isComplaint && i18n.TEXT_WARNING_CASHBACK}
                            {invalidEbon && (
                                <span>
                                    {i18n.TEXT_WARNING_INVALID}
                                    <LocalizedNavLink
                                        to={`${PATH.FAQ_PATH}#${CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED_FAQ}`}
                                        title={i18n.LINK_FAQ}>
                                        {i18n.LINK_FAQ}
                                    </LocalizedNavLink>
                                </span>
                            )}
                            {cashbackNotReceived && i18n.TEXT_WARNING_NOT_RECEIVE}
                        </LegendFieldComponent>
                    ) : null}
                    {!unsubscribe ? (
                        <React.Fragment>
                            <FilesInputFieldComponent
                                name="files"
                                nameForm={FORM_NAME}
                                btText={i18n.BUTTON_CHOOSE_FILE}
                                formatAccepted={FILE_ACCEPTED_FORMAT}
                                maxSize={2}
                                isMultiple
                                classNameInputContainer="full"
                                isRequired={isComplaint}
                                minRequired={isComplaint ? 1 : 0}
                                i18nFeatureForm={i18nFeatureForm}
                            />
                            <TextareaFieldComponent
                                name="message"
                                label={convertHtmlToReactDomWithParams(
                                    i18n.LABEL_MESSAGE,
                                    CONTACT_MESSAGE_LENGTH
                                )}
                                isRequired
                                classNameInputContainer="full"
                                requiredMessage={i18n.TEXT_AREA_REQUIRED_MESSAGE}
                                validate={[
                                    length({
                                        max: CONTACT_MESSAGE_LENGTH,
                                        msg: format(i18n.MESSAGE_SIZE_ERROR, CONTACT_MESSAGE_LENGTH)
                                    })
                                ]}
                            />
                            <LegendFieldComponent classNameInputContainer="full">
                                {i18n.LEGEND_MANDATORY_FIELDS}
                            </LegendFieldComponent>
                            {isAuthed && (
                                <LegendFieldComponent classNameInputContainer="full"></LegendFieldComponent>
                            )}

                            {errorMessage && (
                                <LegendFieldComponent classNameInputContainer="color-err">
                                    {errorMessage}
                                </LegendFieldComponent>
                            )}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="full form-submit-container">
                                <ButtonComponent
                                    id="show-disenroll"
                                    color="main"
                                    text={i18n.BUTTON_UNSUBSCRIBE}
                                    onClick={this.showDisenrollModal}
                                />
                            </div>
                        </React.Fragment>
                    )}
                </FormComponent>
                <SuccessMessageComponent
                    visible={successSubmit}
                    message={i18n.SUBMIT_SUCCEEDED}
                    onClose={this.handleCloseMessage}
                />
            </React.Fragment>
        );
    }
}

ContactRequestFormComponent.propTypes = {
    i18n: PropTypes.object.isRequired,
    contactRequestReasonsOptions: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        errorMessage: state.contactrequest.error,
        requestSubmit: state.contactrequest.fetching || false,
        errorSubmit: !isEmpty(state.contactrequest.errorMessage),
        successSubmit: state.contactrequest.successContactRequestSubmit,
        fetching: state.contactrequest.fetching,
        contactRequestReasonsOptions: getContactRequestReasonsToOptions(
            !isEmpty(state.authentication.token),
            state.contactrequest.contactrequestreasons
        ),
        i18n: state.i18n.page.CONTACTREQUEST,
        i18nFeatureForm: state.i18n.feature.form,
        isAuthed: !isEmpty(state.authentication.token),
        initialValues: {
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            email: user.email ? user.email : ''
        }
    };
}

const mapDispatchtoProps = {
    sendContactRequest,
    reset,
    resetForm,
    change,
    untouch,
    showModal
};

export default withRouter(
    connect(mapStateToProps, mapDispatchtoProps)(ContactRequestFormComponent)
);



// WEBPACK FOOTER //
// ./src/components/pages/contactrequest/ContactRequestFormComponent.js